import { render, staticRenderFns } from "./UserManagement2.vue?vue&type=template&id=5f323554&scoped=true"
import script from "./UserManagement2.vue?vue&type=script&lang=js"
export * from "./UserManagement2.vue?vue&type=script&lang=js"
import style0 from "./UserManagement2.vue?vue&type=style&index=0&id=5f323554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f323554",
  null
  
)

export default component.exports